<template>

  <div class="articlemanagement">
    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="10"
            :lg="10"
          >
          <Divider orientation="left">{{langMap.netGunRecord[lang]}}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="14"
            :lg="14"
          >
          <Form :label-width="80">
            <div class="des-cardTittle-box">
              <FormItem
                :label="langMap.robot[lang]"
                class="leftFlex"
              >
                <Select v-model="robotId" :disabled="isHistoryMode">
                  <Option
                    :key="item.id"
                    :value="item.id"
                    v-for="item in robotList"
                  >{{item.name}}</Option>
                </Select>
              </FormItem>
              <FormItem
                :label="langMap.reportTime[lang]"
                class="leftFlex"
              >
               <Date-picker
                  v-model="times"
                  type="datetimerange"
                  :placeholder="langMap.selectDateAndTime[lang]"
                  format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                  :disabled="isHistoryMode"
                />
              </FormItem>
              <Button
                type="info"
                style="margin-left:20px;"
                @click="onSearchOrRecoverClick"
              >{{ searchButtonText }}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table
        :height="height"
        :loading="tableLoading2"
        border
        :columns="columns"
        :data="dataList"
      ></Table>

      <div
        style="text-align:center;padding-top:10px;"
        v-if="dataList.length>0"
      >
        <Page
          :current="dataIndex"
          :total="dataTotal"
          :page-size="15"
          @on-change="goPageData"
        ></Page>
      </div>

      <!-- 数据详情 -->
      <Modal
        :mask-closable="false"
        v-model="detailedDisplay"
        width="55"
        :title="langMap.dataDetailInfo[lang]"
      >
        <Row>
          <Row>
            <Col span="24">
            <div class="detail-item">
              <div>{{langMap.messageId[lang]}}：</div>
              <span>{{showDetailData.messageId}}</span>
            </div>
            </Col>
          </Row>
          <Col span="24">
          <div class="detail-item">
            <div>{{langMap.taskId[lang]}}：</div>
            <span>{{showDetailData.taskId}}</span>
          </div>
          </Col>
          <Col span="24">
          <div class="detail-item">
            <div>{{langMap.taskInfo[lang]}}：</div>
            <span>{{showDetailData.msg}}</span>
          </div>
          </Col>
          <Col span="24">
          <div class="detail-item">
            <div>{{langMap.imageDetail[lang]}}：</div>
            <span>{{showDetailData.img}}</span>
          </div>
          </Col>
        </Row>
        <div slot="footer">
          <Button
            type="default"
            @click="cancelDetail"
          >{{langMap.cancel[lang]}}</Button>
        </div>
      </Modal>

      <!-- 操作下发记录详情 -->

      <Modal
        :mask-closable="false"
        v-model="issuedDisplay"
        width="55"
        :title="langMap.operationRecordDetail[lang]"
      >
        <Row>
          <Row>
            <Col span="24">
            <div class="detail-item">
              <div>{{langMap.publishTime[lang]}}：</div>
              <span>{{recordVO.publishTime}}</span>
            </div>
            </Col>
          </Row>
          <Col span="24">
          <div class="detail-item">
            <div>{{langMap.publishType[lang]}}：</div>
            <span>{{recordVO.topic}}</span>
          </div>
          </Col>

          <Col span="24">
          <div class="detail-item">
            <div>{{langMap.dataDetails[lang]}}：</div>
            <span>{{recordVO.data}}</span>
          </div>
          </Col>
        </Row>
        <div slot="footer">
          <Button
            type="default"
            @click="issuedDetail"
          >{{langMap.cancel[lang]}}</Button>
        </div>
      </Modal>
    </Card>
  </div>
</template>

<script>
import api from "../../../api/index.js";
import * as timeUtil from "@/utils/dateTimeUtil.js";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      dataIndex: 1,
      dataList: [],
      dataTotal: 0,
      tableLoading2: false,
      times: [],
      isHistoryMode: false,
      dataType: "1",
      robotId: 0,
      title: "",
      robotList: [],

      //
      detailedDisplay: false,
      showDetailData: {},

      issuedDisplay: false,
      recordVO: {},

      buttonDisplay: true,
      //表格
      tableLoading: false,
      code: "",
      name: "",
      type: "",
    };
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        // 根据路由参数决定是否进入回溯查询模式
        this.isHistoryMode = !!newQuery.timestamp;

        if (newQuery.robotId) {
          this.robotId = parseInt(newQuery.robotId);
        }

        // 在回溯模式下，路由变化时直接根据 timestamp 查询
        if (this.isHistoryMode && this.robotId) {
          this.dataIndex = 1;
          this.getDataList();
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    searchButtonText() {
      if (this.isHistoryMode) {
        return this.lang === 'en' ? 'Restore search' : '恢复查询';
      }
      return this.langMap.search[this.lang];
    },
    columns() {
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: this.langMap.robot[this.lang],
          width: 150,
          key: "code"
        },
        {
          title: this.langMap.reportTime[this.lang],
          width: 200,
          key: "timestamp",
          render(h, params) {
            return h("span", timeUtil.formatTime(params.row.timestamp));
          }
        },

        {
          title: this.langMap.dataInfo[this.lang],
          minWidth: 150,
          key: "data",
          render: (h, params) => {
            let data = JSON.parse(params.row.data);
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.detailedDisplay = true;
                      this.showDetailData = data;
                    }
                  }
                },
                this.langMap.dataDetailInfo[this.lang]
              )
            );
            return h("div", renderArray);
          }
        },
        {
          title: this.langMap.operationTime[this.lang],
          width: 200,
          key: "operateTime"
        },
        {
          title: this.langMap.operationType[this.lang],
          width: 200,
          key: "operateType",
          render: (h, { row }) => {
            let text = "";
            if (row.operateType === null) {
              text = "-";
            } else if (row.operateType == 1) {
              text = this.langMap.alreadyAllowed[this.lang];
            } else if (row.operateType == 2) {
              text = this.langMap.alreadyRejected[this.lang];
            } else if (row.operateType == 3) {
              text = this.langMap.publishFailed[this.lang];
            }
            return h("span", text);
          }
        },
        {
          title: this.langMap.operationRecord[this.lang],
          width: 200,
          key: "recordVO",

          render: (h, params) => {
            if (params.row.recordVO !== null) {
              let recordVO = params.row.recordVO;
              //渲染数组
              var renderArray = [];
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        this.issuedDisplay = true;
                        this.recordVO = recordVO;
                      }
                    }
                  },
                  this.langMap.operationRecordDetail[this.lang]
                )
              );
              return h("div", renderArray);
            }
          }
        },
        {
          width: 200,
          title: this.langMap.operation[this.lang],
          align: "center",
          render: (h, params) => {
            if (params.row.operateType === null) {
              //渲染数组
              let renderArray = [];
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "success",
                      size: "small"
                    },
                    style: {
                      marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: this.langMap.systemTip[this.lang],
                          content: this.langMap.confirmRejectOperation[this.lang],
                          okText: this.langMap.confirm[this.lang],
                          cancelText: this.langMap.cancel[this.lang],
                          onOk: () => {
                            this.$Spin.show();
                            let data = params.row;
                            this.instructInfo(data);
                            this.$Spin.hide();
                          }
                        });
                      }
                    }
                  },
                  this.langMap.reject[this.lang]
                )
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {},
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: this.langMap.systemTip[this.lang],
                          content: this.langMap.confirmOpenNetGun[this.lang],
                          okText: this.langMap.confirm[this.lang],
                          cancelText: this.langMap.cancel[this.lang],
                          onOk: () => {
                            let robotId = params.row.robotId;
                            let d = {
                              timestamp: params.row.timestamp,
                              flag: true
                            };
                            this.$Spin.show();
                            api
                              .postData(
                                "notice-server/cmd/gun",
                                { robotId: robotId, data: d },
                                this
                              )
                              .then(res => {
                                if (res.state == 0) {
                                  this.$Notice.error({
                                    title: this.langMap.tip[this.lang],
                                    desc: res.msg
                                  });
                                } else {
                                  this.$Notice.success({
                                    title: this.langMap.success[this.lang],
                                    desc: res.message
                                  });
                                  this.getDataList();
                                }
                                this.$Spin.hide();
                              });
                          }
                        });
                      }
                    }
                  },
                  this.langMap.allow[this.lang]
                )
              );
              return h("div", renderArray);
            }
          }
        }
      ];
    }
  },
  methods: {
    cancelDetail() {
      this.detailedDisplay = false;
    },

    issuedDetail() {
      this.issuedDisplay = false;
    },

    //获取列表
    getList() {
      this.tableLoading = true;
      api.getData("robot-server/robot/list/all", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.robotList = res.data;
          if (this.robotList.length > 0) {
            // 如果外部（路由）已经指定了 robotId，就优先用外部的
            if (!this.robotId) {
              this.robotId = this.robotList[0].id;
            } else {
              // 确认当前 robotId 是否在列表中，否则回退到第一个
              const exists = this.robotList.some(r => String(r.id) === String(this.robotId));
              if (!exists) {
                this.robotId = this.robotList[0].id;
              }
            }
            this.getDataList();
          }
        }
        this.tableLoading = false;
      });
    },
    // 查询 / 恢复查询 按钮点击
    onSearchOrRecoverClick() {
      if (this.isHistoryMode) {
        // 从回溯模式恢复为普通查询模式
        const query = { ...this.$route.query };
        delete query.timestamp;
        this.isHistoryMode = false;
        this.times = [];
        this.dataIndex = 1;
        this.$router.push({ path: this.$route.path, query });
      } else {
        this.searchData();
      }
    },
    //搜索数据
    searchData() {
      this.dataIndex = 1;
      this.getDataList();
    },
    //分页数据
    goPageData(index) {
      this.dataIndex = index;
      this.getDataList();
    },
    getDataList() {
      if (!this.robotId) {
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: this.langMap.pleaseSelectRobot[this.lang]
        });
        return;
      }
      this.dataList = [];
      this.dataTotal = 0;

      let url =
        "notice-server/data/gun/list?robotId=" + this.robotId;

      const timestamp = this.$route.query.timestamp;

      if (timestamp) {
        // 回溯模式下，直接使用 timestamp 入参查询
        url += "&timestamp=" + timestamp;
      } else {
        let start = "";
        let end = "";
        if (this.times.length == 2) {
          if (this.times[0]) {
            start = timeUtil.formatTime(this.times[0]);
          }
          if (this.times[1]) {
            end = timeUtil.formatTime(this.times[1]);
          }
        }
        url += "&start=" + start + "&end=" + end;
      }

      url += "&index=" + this.dataIndex;

      this.tableLoading2 = true;
      api
        .getData(
          url,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.dataList = res.data.rows;
            this.dataTotal = res.data.total;
          }
          this.tableLoading2 = false;
        });
    },

    // 发送指令
    instructInfo(data) {
      let robotId = data.robotId;
      let d = {
        timestamp: data.timestamp,
        flag: false
      };
      api
        .postData("notice-server/cmd/gun", { robotId: robotId, data: d }, this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.$Notice.success({
              title: langMap.success[this.lang],
              desc: res.message
            });

            this.getDataList();
          }
          this.$Spin.hide();
        });
    }
  },
  created() {
    // 根据路由参数初始化回溯查询模式和机器人
    this.isHistoryMode = !!this.$route.query.timestamp;

    if (this.$route.query.robotId) {
      this.robotId = parseInt(this.$route.query.robotId);
    }

    this.getList();
  }
};
</script>

<style lang="less" scoped>
.detail-item {
  display: flex;
  border: 1px solid #e8eaec;
  margin-bottom: -1px;
  line-height: 30px;
  padding-bottom: 2px;
  padding-left: 8px;
}

/deep/.ivu-btn-success {
  background-color: #ff9900;
  border-color: #ff9900;
}

/deep/.ivu-btn-warning {
  background-color: #e23f24;
  border-color: #e23f24;
}
</style>
